import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: "-1",
  id: "foilTestModal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, /*#__PURE__*/_toDisplayString(`Enter a New Ultrasonic Foil Test`), -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)
const _hoisted_8 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: "-1",
  id: "washerTestModal"
}
const _hoisted_9 = { class: "modal-dialog" }
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = { class: "modal-header" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, /*#__PURE__*/_toDisplayString(`Enter a New Washer Test`), -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_KTLoader, {
          key: 0,
          logo: _ctx.loaderLogo
        }, null, 8, ["logo"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_avatar),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeQuery && _ctx.removeQuery(...args))),
                class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, [
                _hoisted_7,
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_avatar),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeQuery && _ctx.removeQuery(...args))),
                class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, [
                _hoisted_14,
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}